import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { ControlPosition, IControl } from 'mapbox-gl'
import { Icon } from '@iconify/vue2'
import { useMapBox } from './composables/useMapBox'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxDrawDeleteControl',
  props: {
    position: null
  },
  setup(__props: any) {

const props = __props as {
	position?: ControlPosition
};

const { map, draw } = useMapBox()



let control: IControl | undefined

const drawPolygonButton = ref<HTMLElement>()

function deleteSelectedDrawFeature() {
	if (!draw?.value) return
	draw.value.trash()
}

onMounted(() => {
	let container: HTMLDivElement

	control = {
		onAdd() {
			container = document.createElement('div')
			container.className = 'mapboxgl-ctrl'

			drawPolygonButton.value?.addEventListener('click', () => deleteSelectedDrawFeature())

			container.appendChild(drawPolygonButton.value!)

			return container
		},
		onRemove() {
			container?.remove()
		},
	}

	map?.value?.addControl(control!, props.position || 'top-right')
})

onUnmounted(() => {
	if (control) map?.value?.removeControl(control)
})

return { __sfc: true,map, draw, props, control, drawPolygonButton, deleteSelectedDrawFeature, Icon }
}

})